type Bundle = typeof import('@yandex-int/messenger.widget')

let bundlePromise: Promise<Bundle>

export const loadMessengerWidgetBundle = (): Promise<Bundle> => {
  if (!bundlePromise) {
    bundlePromise = Promise.all([
      import(/* webpackChunkName: "messenger-popup-css" */ '@yandex-int/messenger.widget/lib/ui/supportpopup.css'),
      import(/* webpackChunkName: "messenger-block-css" */ '@yandex-int/messenger.widget/lib/ui/block.css'),
    ]).then(() => import(/* webpackChunkName: "messenger-js" */ '@yandex-int/messenger.widget'))
  }

  return bundlePromise
}
